{
  "label_show-password": "Показать пароль",
  "label_hide-password": "Скрыть пароль"
}
